import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import FadeInBox from "../../../../../../commonComponents/FadeInBox";

const Service = ({ service }) => {
  return (
    <Card
      sx={{
        maxWidth: "350px",
        height: "420px",
        boxShadow: "none",
        border: "1px solid #ddd",
        fontFamily: "Montserrat",
        justifyContent: "center",
      }}
    >
      <CardMedia sx={{ height: 240 }} image={service.image} />
      <CardContent sx={{ justifyContent: "center" }}>
        <FadeInBox
          delay={0}
          duration={1.2}
          translateY={20}
          triggerOnScroll={true}
          triggerOnMount={false}
        >
          <Typography
            gutterBottom
            variant="h5"
            component="div"
            sx={{
              fontFamily: "Montserrat",
              fontWeight: 600,
              fontSize: "15px",
              lineHeight: "30px",
              textAlign: "center",
              mb: 1,
            }}
          >
            {service.title}
          </Typography>
        </FadeInBox>
        <FadeInBox
          delay={0.4}
          duration={1.2}
          translateY={20}
          triggerOnScroll={true}
          triggerOnMount={false}
        >
          <Typography
            sx={{
              textAlign: "center",
              fontFamily: "Montserrat",
              fontWeight: 400,
              fontSize: "15px",
              lineHeight: "18.29px",
            }}
          >
            {service.description}
          </Typography>
        </FadeInBox>
      </CardContent>
    </Card>
  );
};
export default Service;
